module.exports = __webpack_public_path__ + "static/curb-island-1200x600-c294e4ecf12679be3a0de63388d1c118.jpg";